import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export enum SeoDataState {
    LOADING = "LOADING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}

interface SeoState {
    storeState: SeoDataState;
    footerData: string;
    title: string;
    description: string;
    schemas: any[];
}

// Define initial state
const initialState: SeoState = {
    storeState: SeoDataState.LOADING,
    footerData: "",
    title: "",
    description: "",
    schemas: []
};

// Create the slice
const seoSlice = createSlice({
    name: 'seo',
    initialState,
    reducers: {
        
        setSeoData: (state, action: PayloadAction<any>) => {
            state.storeState = SeoDataState.SUCCESS;
          
            Object.assign(state, action.payload);
        },
       
        resetSeoData: (state) => {
            state.storeState = SeoDataState.LOADING;
            state.footerData = "";
            state.title = "";
            state.description = "";
            state.schemas = [];
        },
      
        setSeoError: (state) => {
            state.storeState = SeoDataState.ERROR;
        }
    }
});


export const { setSeoData, resetSeoData, setSeoError } = seoSlice.actions;

export default seoSlice.reducer;